import mixins from 'synergycms_core/src/less/mixins';
export default {
  titleListBlock: {},
  tabContent: {},
  tabTitle: {},
  test: {},
  listContainer: {
    padding: '12px 15px 0',
    textAlign: 'left',
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  monoHotelList: {
    margin: '0',
    padding: '0',
    display: 'table',
    borderSpacing: '1px 0',
    width: '100%',
    borderBottom: '1px solid #d8d8d8',
    '@media (min-width: 601px)': {
      width: 'auto'
    },
    '@media (min-width: 801px)': {
      marginLeft: '20px',
    },
    '& li': {
      display: 'table-cell',
      verticalAlign: 'bottom',
      textAlign: 'center',
      width: '33%',
      listStyle: 'none',
      '& button': {
        textTransform: "uppercase",
        padding: "10px",
        minHeight: "42px",
        position: "relative",
        width: "100%",
        font: data => '13px ' + data.fontFamily1,
        '& span:first-of-type': {
          font: data => '18px ' + data.fontFamily3,
          position: 'relative',
          marginRight: '3px',
          '&:lang(ar)': {
            marginRight: 0,
            marginLeft: '3px'
          }
        },
        '& span': {
          verticalAlign: 'middle'
        }
      }
    },
    '& $titleListBlock': {
      '@media (min-width: 801px)': {
        padding: '0 25px'
      },
      textAlign: 'left',
      borderBottom: '1px solid #d2d2d2',
      '& li': {
        display: 'inline-block',
        marginBottom: '-2px',
        height: 'auto'
      },
      '& $tabTitle': {
        padding: '20px 5px',
        marginRight: '25px',
        background: 'none',
        textTransform: 'none',
        font: data => '16px ' + data.fontFamily1,
        letterSpacing: '1px'
      },
      '&:lang(ar)': {
        textAlign: 'right'
      }
    },
    '& $selected': {
      borderBottom: data => '2px solid ' + data.mainColor,
      color: data => data.mainColor
    },
    '&:lang(ar)': {
      marginLeft: 0,
      marginRight: '20px'
    }
  },
  listPrices: {
    display: 'table',
    font: data => '13px ' + data.fontFamily1,
    width: '100%',
    padding: '0 20px',
    ...mixins.boxSizing(),
    margin: '0',
    position: 'sticky',
    left: '0',
    right: '0',
    background: '#fff',
    top: '0',
    zIndex: '2',
    '@media (min-width: 801px)': {
      position: 'relative',
      borderBottom: '1px solid #d2d2d2',
      background: 'transparent',
      paddingRight: '50px',
      ...mixins.boxShadow('none'),
      textAlign: 'left',
    },
    '& li': {
      display: 'table-cell',
      width: '50%',
      verticalAlign: 'middle',
      position: 'relative',
      ...mixins.transition('color .3s'),
      '@media (min-width: 801px)': {
        display: 'inline-block',
        width: 'auto',
        '& :not(:first-child)': {
          marginLeft: '35px',
          '&:lang(ar)': {
            marginLeft: 0,
            marginRight: '35px'
          }
        }
      },
      '& button': {
        textTransform: 'uppercase',
        width: '100%',
        padding: '10px 0',
        textAlign: 'center',
        '@media (min-width: 801px)': {
          padding: '10px 5px',
          height: '65px',
        },
        '&:after': {
          content: "''",
          position: 'absolute',
          left: '0',
          bottom: '0',
          right: '0',
          height: '0',
          background: 'transparent',
          ...mixins.transition('.3s')
        },
        '& span': {
          font: data => '400 13px ' + data.fontFamily1,
          '@media (min-width: 801px)': {
            textTransform: 'none',
            letterSpacing: '1px',
            fontSize: '16px'
          }
        },
        '& $selected': {
          '&:after': {
            height: '3px',
            background: data => data.mainColor
          },
          '& span': {
            color: data => data.mainColor
          }
        }
      }
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        textAlign: 'right'
      }
    }
  },
  selected: {
    '&:before': {
      height: '3px',
      content: "''",
      background: data => data.mainColor,
      right: '0',
      position: 'absolute',
      bottom: '-2px',
      left: '0',
      ...mixins.transition('height .3s')
    },
    '&.hasLoyaltyUser': {
      background: 'white',
      '& span': {
        color: '#4F5D70',
        border: 'none',
        padding: '0'
      }
    }
  },
  hasLoyaltyUser: {},
  counterSpan:{
    color: '#9b9b9b'
  },
  listNoDatepicker:{
    display: 'table',
    font: data => '13px ' + data.fontFamily1,
    width: '100%',
    padding: '0 20px !important',
    ...mixins.boxSizing(),
    margin: '0',
    background: '#fff',
    '@media (min-width: 801px)': {
      position: 'relative',
      borderBottom: '1px solid #d2d2d2',
      background: 'transparent',
      paddingRight: '50px !important',
      ...mixins.boxShadow('none'),
      textAlign: 'left',
    },
    '& li': {
      display: 'table-cell',
      width: '50%',
      verticalAlign: 'middle',
      position: 'relative',
      ...mixins.transition('color .3s'),
      '@media (min-width: 801px)': {
        display: 'inline-block',
        width: 'auto',
        '& :not(:first-child)': {
          marginLeft: '35px',
          '&:lang(ar)': {
            marginLeft: 0,
            marginRight: '35px'
          }
        }
      }
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        textAlign: 'right'
      }
    }
  }
};
